<template>
    <div>
        <div class="top">
            <span>{{ houseName }}</span>
            <span class="inlineblock">{{
                '房间代码:' + '\u3000' + houseNo
            }}</span>
        </div>
        <div>
            <div :class="preCls + 'filter'" style="margin-top: 10px">
                <filter-date-range
                    :startDate.sync="filter.startDate"
                    :endDate.sync="filter.endDate"
                    @on-change="search"
                ></filter-date-range>
            </div>
            <div style="margin-top: 10px">
                <Table
                    ref="mt"
                    :columns="columns"
                    :data="page.list"
                    :loading="loading"
                    :height="mtHeight"
                >
                    <template v-slot:action="{ row }">
                        <Button
                            size="small"
                            style="margin-right: 5px"
                            @click="rowClickDetail(row)"
                            >详情</Button
                        >
                    </template>

                    <template v-slot:cusType="{ row }">
                        {{ dict.cusType.val(row.cusType) }}
                    </template>
                    <template v-slot:createTime="{ row }">
                        {{ row.createTime | ymdL }}
                    </template>
                </Table>
                <!-- 底部分页 -->
                <table-pager
                    transfer
                    :total.sync="page.totalCount"
                    :pageSize.sync="filter.pageSize"
                    :pageNo.sync="filter.page"
                    @change="fetch"
                ></table-pager>
                <!-- 弹出层 -->
                <smart-modal
                    v-model="modal.showCusInfo"
                    title="租客信息详情"
                    :width="800"
                    :height="420"
                    :maskClosable="false"
                >
                    <cus-info-form
                        v-if="modal.showCusInfo"
                        :id="id"
                    ></cus-info-form>
                </smart-modal>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import Dict from '_u/dict'
import { updatelogList, updatelogView } from '@/api/contract'
import CusInfoForm from './cus-info-form'
import FilterDateRange from '_v/components/filter/filter-date-range'

export default {
    components: {
        CusInfoForm,
        FilterDateRange,
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    props: {
        houseName: {
            type: String,
            default: '',
        },
        houseNo: {
            type: String,
            default: '',
        },
        contractId: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        return {
            mtHeight: 360,
            filter: {
                page: 1,
                pageSize: 20,
                contractId: this.contractId,
                startDate: '',
                endDate: '',
            },
            info: {},
            loading: false,
            page: {
                totalCount: 0,
                list: [],
            },

            dict: {
                cusType: Dict.NULL,
            },
            id: '',
            modal: {
                showCusInfo: false,
            },
        }
    },
    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    width: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    title: '修改时间',
                    key: 'createTime',
                    align: 'center',
                    minWidth: 150,
                    tooltip: true,
                    slot: 'createTime',
                },
                {
                    title: '租客身份',
                    key: 'cusType',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                    slot: 'cusType',
                },
                {
                    title: '租客姓名',
                    key: 'cusName',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    title: '手机号',
                    key: 'cusMobile',
                    align: 'right',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    title: '单位名称',
                    key: 'comName',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    title: '税号',
                    key: 'taxNum',
                    align: 'right',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 100,
                    fixed: 'right',
                    slot: 'action',
                },
            ]
        },
    },
    methods: {
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        rowClickDetail(row) {
            this.id = row.id
            this.modal.showCusInfo = true
        },
        fetch() {
            this.loading = true
            Promise.all([Dict.get(['cus_type']), updatelogList(this.filter)])
                .then((args) => {
                    var [dictGroup, view] = args
                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                    this.page.list = view.data.page.list
                    this.page.totalCount = parseInt(view.data.page.totalCount)
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
    mounted() {
        var btns = [{ type: 'default', text: '关闭', name: 'cancel' }]
        this.$modal.updateBtns(btns)

        // 预加载
        // this.$modal.beforeEnter((next) => {
        //     Promise.all([this.fetch()]).finally(() => {
        //         next();
        //     });
        // });
    },
    created() {
        this.fetch()
    },
}
</script>

<style lang="less" scoped>
.top {
    font-size: 20px;
}
.inlineblock {
    display: inline-block;
    margin-left: 20px;
    font-size: 16px;
    color: rgb(75, 191, 249);
}
</style>
